import {
  SegmentedRadioGroupProps,
  SegmentedRadioGroup,
  Theme,
} from "@gravity-ui/uikit";
import { useAtom } from "@reatom/npm-react";
import { themeAtom } from "src/store/atoms/themeAtom";

import { themes } from "./ThemeBlock.constants";

export const ThemeBlock = ({ ...props }: SegmentedRadioGroupProps) => {
  const [theme, setTheme] = useAtom(themeAtom);

  return (
    <SegmentedRadioGroup<Theme>
      size={"l"}
      onChange={(event) => setTheme(event.target.value as Theme)}
      defaultValue={"system"}
      options={themes}
      {...props}
      value={theme}
    />
  );
};
